var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section-checkout" },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-1 d-none d-lg-block" }, [_vm._v(" ")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-lg-6 col-12" },
          [
            _vm.preCheckoutData &&
            _vm.preBookingData &&
            _vm.preBookingData.is_repeat_booking
              ? _c("repeat-booking")
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                class: { "card shadow-sm": !_vm.$mq.phone },
                attrs: { id: "checkout-content" }
              },
              [
                _c(
                  "div",
                  { class: { "card-body px-1 py-3": !_vm.$mq.phone } },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-12 mt-2",
                          class: { "p-0": _vm.$mq.phone }
                        },
                        [
                          _c("h3", { staticClass: "booking-title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("message.booking.checkout_step.title")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _vm.preCheckoutData
                            ? _c(
                                "section",
                                { staticClass: "mt-4" },
                                [
                                  _c("h4", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.booking.checkout_step.customer"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("contact-form", {
                                    ref: "contactForm",
                                    on: {
                                      savedLocation: _vm.clearLocationError
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.errors.has("location")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-2 text-remark -status-alert"
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-exclamation-triangle"
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "message.required_pin_location"
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _c("section", [_c("loader")], 1),
                          _vm._v(" "),
                          _vm.preCheckoutData
                            ? _c("section", { staticClass: "mt-4" }, [
                                _c("h4", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "message.booking.checkout_step.tax_invoice"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "card shadow-sm" }, [
                                  _c("div", { staticClass: "card-body" }, [
                                    _c("div", { staticClass: "exp" }, [
                                      _c("div", { staticClass: "checkbox" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.preCheckoutData
                                                  .request_receipt,
                                              expression:
                                                "preCheckoutData.request_receipt"
                                            }
                                          ],
                                          attrs: {
                                            type: "checkbox",
                                            id: "requestReceipt",
                                            name: "requestReceipt"
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.preCheckoutData
                                                .request_receipt
                                            )
                                              ? _vm._i(
                                                  _vm.preCheckoutData
                                                    .request_receipt,
                                                  null
                                                ) > -1
                                              : _vm.preCheckoutData
                                                  .request_receipt
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a =
                                                  _vm.preCheckoutData
                                                    .request_receipt,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.preCheckoutData,
                                                      "request_receipt",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.preCheckoutData,
                                                      "request_receipt",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.preCheckoutData,
                                                  "request_receipt",
                                                  $$c
                                                )
                                              }
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "mb-0",
                                            attrs: { for: "requestReceipt" }
                                          },
                                          [
                                            _c("span"),
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.booking.checkout_step.request_tax_invoice"
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ]
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _vm.preCheckoutData.request_receipt
                                      ? _c(
                                          "div",
                                          { staticClass: "mt-2" },
                                          [
                                            _vm._.isEmpty(_vm.companies) ||
                                            !_vm.preCheckoutData.user_company
                                              ? [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-light btn-block card-dashed mt-3 py-2 text-center",
                                                      on: {
                                                        click:
                                                          _vm.openUserCompanyModal
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fas fa-plus-circle"
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.company_address.add_new_address_for_receipt"
                                                            )
                                                          ) +
                                                          "\n                        "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : [
                                                  _vm.preCheckoutData
                                                    .user_company
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-comment"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex align-items-center justify-content-start mt-4 mb-2"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "flex-fill"
                                                                },
                                                                [
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .preCheckoutData
                                                                          .user_company
                                                                          .company
                                                                      )
                                                                    )
                                                                  ])
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "flex-fill text-right"
                                                                },
                                                                [
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .preCheckoutData
                                                                          .user_company
                                                                          .tel
                                                                      )
                                                                    )
                                                                  ])
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("div", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .preCheckoutData
                                                                  .user_company
                                                                  .address
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "mt-3 text-right"
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "text-primary-link",
                                                                  attrs: {
                                                                    href: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.preventDefault()
                                                                      return _vm.openUserCompanyModal.apply(
                                                                        null,
                                                                        arguments
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "message.booking.checkout_step.edit_data"
                                                                      )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                            _vm._v(" "),
                                            _vm.preCheckoutData.request_receipt
                                              ? _c("input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: "required",
                                                      expression: "'required'"
                                                    },
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.preCheckoutData
                                                          .user_company,
                                                      expression:
                                                        "preCheckoutData.user_company"
                                                    }
                                                  ],
                                                  attrs: {
                                                    type: "hidden",
                                                    name: "userCompany",
                                                    id: "userCompany"
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.preCheckoutData
                                                        .user_company
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.preCheckoutData,
                                                        "user_company",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.errors.has("userCompany")
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "mt-2 text-remark -status-alert"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.required_field"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ])
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.preCheckoutData && _vm.checkoutConditions
                            ? _c(
                                "section",
                                { staticClass: "mt-4" },
                                [
                                  _c("customer-area-photo", {
                                    attrs: {
                                      checkoutConditions: _vm.checkoutConditions
                                    },
                                    on: {
                                      setAdditionalRemark:
                                        _vm.callbackAdditonalRemark
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.preCheckoutData &&
                          _vm.preBookingData.service_id === 1 &&
                          _vm.displayExtras
                            ? _c(
                                "section",
                                { staticClass: "mt-4" },
                                [
                                  _c("extra-form", {
                                    attrs: { hasProfessional: false }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.preCheckoutData &&
                          _vm.globalState.configData
                            .display_has_ironing_board &&
                          _vm.hasIroningService
                            ? _c(
                                "section",
                                { staticClass: "mt-4" },
                                [_c("has-ironing-board")],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "section",
                            {
                              staticClass: "d-lg-none",
                              attrs: { id: "summary-booking-mobile" }
                            },
                            [
                              _c("div", { staticClass: "card shadow-sm" }, [
                                _c(
                                  "div",
                                  { staticClass: "card-body" },
                                  [
                                    _c("summary-booking-mobile"),
                                    _vm._v(" "),
                                    _c("checkout-cost"),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "text-remark mt-3" },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.booking.summary.all_inclusive_title"
                                              )
                                            ) +
                                            "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.booking.summary.all_inclusive_general_cleaning"
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm.preCheckoutData && _vm.totalPrice >= 20
                            ? _c("section", { staticClass: "mt-4" }, [
                                _c("h4", { attrs: { id: "paymentMethod" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "message.booking.checkout_step.payment_method"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card shadow-sm",
                                    attrs: { id: "user-credit-cards" }
                                  },
                                  [
                                    _c("div", { staticClass: "card-body" }, [
                                      _c("div", { staticClass: "exp" }, [
                                        _c("div", { staticClass: "checkbox" }, [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.preCheckoutData
                                                    .payment_method,
                                                expression:
                                                  "preCheckoutData.payment_method"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              type: "radio",
                                              id: "paymentCreditDebit",
                                              name: "paymentMethod",
                                              value: "credit_card"
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.preCheckoutData
                                                  .payment_method,
                                                "credit_card"
                                              )
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.$set(
                                                  _vm.preCheckoutData,
                                                  "payment_method",
                                                  "credit_card"
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "mb-0",
                                              attrs: {
                                                for: "paymentCreditDebit"
                                              }
                                            },
                                            [
                                              _c("span"),
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.booking.payment_step.pay_by_credit_debit_card"
                                                    )
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _vm.preCheckoutData.payment_method ===
                                      "credit_card"
                                        ? _c(
                                            "div",
                                            { staticClass: "pt-2" },
                                            [
                                              _c("user-credit-cards", {
                                                attrs: {
                                                  canEditCard: false,
                                                  action: "checkout_payment"
                                                },
                                                on: {
                                                  onSelected:
                                                    _vm.applyUserCreditCard,
                                                  onAddNewCard:
                                                    _vm.addNewCreditCard
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "card shadow-sm" }, [
                                  _c("div", { staticClass: "card-body" }, [
                                    _c("div", { staticClass: "exp" }, [
                                      _c("div", { staticClass: "checkbox" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.preCheckoutData
                                                  .payment_method,
                                              expression:
                                                "preCheckoutData.payment_method"
                                            }
                                          ],
                                          ref: "bankTransfer",
                                          attrs: {
                                            type: "radio",
                                            id: "bankTransfer",
                                            name: "paymentMethod",
                                            value: "bank_transfer"
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.preCheckoutData
                                                .payment_method,
                                              "bank_transfer"
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                _vm.preCheckoutData,
                                                "payment_method",
                                                "bank_transfer"
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "mb-0",
                                            attrs: { for: "bankTransfer" }
                                          },
                                          [
                                            _c("span"),
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.booking.payment_step.pay_by_bank_transfer"
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "card shadow-sm" }, [
                                  _c("div", { staticClass: "card-body py-3" }, [
                                    _vm.globalState.configData.promptpay
                                      .status === 1
                                      ? _c("div", { staticClass: "exp" }, [
                                          _c(
                                            "div",
                                            { staticClass: "checkbox" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.preCheckoutData
                                                        .payment_method,
                                                    expression:
                                                      "preCheckoutData.payment_method"
                                                  }
                                                ],
                                                ref: "promptpay",
                                                attrs: {
                                                  type: "radio",
                                                  id: "promptpay",
                                                  name: "paymentMethod",
                                                  value: "promptpay"
                                                },
                                                domProps: {
                                                  checked: _vm._q(
                                                    _vm.preCheckoutData
                                                      .payment_method,
                                                    "promptpay"
                                                  )
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.$set(
                                                      _vm.preCheckoutData,
                                                      "payment_method",
                                                      "promptpay"
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "mb-0",
                                                  attrs: { for: "promptpay" }
                                                },
                                                [
                                                  _c("span"),
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.booking.payment_step.pay_by_promptpay"
                                                        )
                                                      ) +
                                                      "\n                          "
                                                  ),
                                                  _c("img", {
                                                    staticClass: "rounded ml-2",
                                                    attrs: {
                                                      src:
                                                        "/static/img/thai_qr_payment.png",
                                                      width: "90"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      : _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-items-center justify-content-start"
                                            },
                                            [
                                              _vm._m(0),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "pl-3" },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "message.booking.payment_step.pay_by_promptpay"
                                                        )
                                                      ) +
                                                      "\n                        "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._m(1)
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "pt-3 text-small" },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$i18n.locale === "th"
                                                      ? _vm.globalState
                                                          .configData.promptpay
                                                          .remark_th
                                                      : _vm.globalState
                                                          .configData.promptpay
                                                          .remark_en
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.preCheckoutData &&
                                _vm.preCheckoutData.wallet &&
                                Number(
                                  _vm.preCheckoutData.wallet.balance_amount
                                ) > 0 &&
                                !_vm.preBookingData.subscription_type_id
                                  ? _c(
                                      "div",
                                      { staticClass: "card shadow-sm" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "card-body" },
                                          [
                                            _c("div", { staticClass: "exp" }, [
                                              _c(
                                                "div",
                                                { staticClass: "checkbox" },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.preCheckoutData
                                                            .payment_method,
                                                        expression:
                                                          "preCheckoutData.payment_method"
                                                      }
                                                    ],
                                                    attrs: {
                                                      type: "radio",
                                                      id: "wallet",
                                                      name: "paymentMethod",
                                                      value: "wallet",
                                                      disabled: !_vm.isAvailableBalance()
                                                    },
                                                    domProps: {
                                                      checked: _vm._q(
                                                        _vm.preCheckoutData
                                                          .payment_method,
                                                        "wallet"
                                                      )
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.$set(
                                                          _vm.preCheckoutData,
                                                          "payment_method",
                                                          "wallet"
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "mb-0",
                                                      class: {
                                                        "text-secondary": !_vm.isAvailableBalance()
                                                      },
                                                      attrs: { for: "wallet" }
                                                    },
                                                    [
                                                      _c("span"),
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.booking.payment_step.pay_by_wallet"
                                                            )
                                                          ) +
                                                          "\n                          "
                                                      ),
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f("currency")(
                                                              _vm
                                                                .preCheckoutData
                                                                .wallet
                                                                .balance_amount
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  !_vm.isAvailableBalance()
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-error small"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "message.booking.payment_step.insufficient_balance"
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.errors.has("paymentMethod")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mt-2 text-remark -status-alert"
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fas fa-exclamation-triangle"
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.required_selection"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("terms-conditions"),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-4" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-info btn-block btn-lg",
                                attrs: {
                                  disabled:
                                    _vm.state.isAddingOrder ||
                                    _vm.hasUnavailableServiceArea()
                                },
                                on: { click: _vm.submitBooking }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t(_vm.isAddingOrder)) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "py-4 pb-sm-0 text-center" },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: "" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.$router.go(-1)
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fas fa-angle-left" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "message.booking.new_booking.back"
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-4 d-none d-lg-block" }, [
          _c(
            "div",
            {
              directives: [{ name: "sticky", rawName: "v-sticky" }],
              attrs: { "sticky-offset": "{top: 120, bottom: 20}" }
            },
            [_c("summary-booking-desktop")],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-1 d-none d-lg-block" }, [_vm._v(" ")])
      ]),
      _vm._v(" "),
      _c(
        "sweet-modal",
        {
          ref: "submittingBookingModal",
          attrs: {
            "overlay-theme": "dark",
            "hide-close-button": _vm.hideCloseButton,
            blocking: _vm.hideCloseButton
          }
        },
        [
          _c("loader"),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("message.booking.payment_step.sending_request")) +
              "\n  "
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("company-address-modal", {
        ref: "userCompanyModal",
        attrs: { manageData: true }
      }),
      _vm._v(" "),
      _c("snackbar", {
        ref: "snackbar",
        attrs: {
          baseSize: "100px",
          colors: {
            open: "#333",
            info: "#3DBD7D",
            error: "#FA7377",
            warn: "#FF6600"
          },
          holdTime: 2500,
          position: "bottom-center"
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("i", { staticClass: "fas fa-circle fa-lg -status-offline" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        staticClass: "rounded ml-2",
        attrs: { src: "/static/img/thai_qr_payment.png", width: "90" }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e1d819b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e1d819b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/CheckoutPage.vue
// module id = 1855
// module chunks = 0